/* eslint-disable no-param-reassign,no-unused-expressions */
/* global G */
import { getFirstItem, isArr } from 'lib/util'
import { date, sortBy } from 'lib/util/array'
import { defaultSettings } from 'platform/adapter/settings/helper/settings'

/**
 * Sets an item on the adapters `G.DATA` by either adding a new
 * value or updating an existing one.
 *
 * Calls the `update` method afterward to update the remote
 * document.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {(function({key: *, value: *, ns?: null}): Promise<*|undefined>)|*}
 */
const fn = app => async ({ key, newKey, value, ns = null }) => {
  const settings = app[G.ADAPTER][G.SETTINGS][G.DATA]

  if (ns && !settings[ns]) {
    if (defaultSettings[ns] === undefined) {
      throw new Error(`Could not obtain default value for settings namespace: ${ns}`)
    } else {
      settings[ns] = defaultSettings[ns]
    }
  }

  let target = ns ? settings[ns] : settings

  const alreadyAdded = target?.findIndex?.(x => x?.key === key)
  if (ns === 'recents' && getFirstItem(target)?.key !== key && alreadyAdded === -1) {
    target = sortBy(target, date('timestamp'))

    if (target.length >= 20) {
      target.splice(19)
    }

    target.unshift({ key, ...value, timestamp: new Date().toISOString() })

    return await app[G.ADAPTER][G.SETTINGS][G.API].apply()
  }

  if (isArr(target)) {
    alreadyAdded !== -1
      ? target[alreadyAdded] = { ...target[alreadyAdded] || {}, key: newKey || key, ...value }
      : target.push({ key, ...value })
  } else {
    target[key] = value
  }

  return await app[G.ADAPTER][G.SETTINGS][G.API].apply()
}

export default fn
